$('.module--faq__items__item__title').click(function () {
  const $this = $(this);
  $this.toggleClass('active').next().slideToggle();
  $('.module--faq__items__item__title').not($this).removeClass('active');
  $('.module--faq__items__item__content').not($this.next()).slideUp();
});
